const generateProductTitle = item => {
  const { modifiers, product } = item
  if (
    modifiers?.vehicle?.isFit &&
    modifiers?.vehicle?.product?.title
  ) {
    return modifiers?.vehicle?.product?.title
  }
  return product?.title
}

export default generateProductTitle
